// eslint-disable-next-line no-restricted-imports
import { CustomMetricType } from '@glovo/custom-metrics'
// eslint-disable-next-line no-restricted-imports
import type { OtelMetric } from '@glovo/custom-metrics'

type MetricDefinition = OtelMetric & { name: `${string}__${string}__${string}` }

export enum CustomMetricName {
  TEST = 'glovoapp__customer-web-react__test_count',
  SERVER_OVERLOAD = 'glovoapp__customer_web_react__server_overload',
}

export const metricsDefinitions: MetricDefinition[] = [
  {
    name: CustomMetricName.TEST,
    description: 'test metric',
    type: CustomMetricType.COUNT,
  },
  {
    name: CustomMetricName.SERVER_OVERLOAD,
    description: 'server overload metric',
    type: CustomMetricType.COUNT,
  },
]
